<template>
  <div class="stars-rating d-flex flex-row-reverse justify-content-end">
    <component
      :is="componentName"
      v-for="value in ratingValues"
      :key="value"
      variant="naked"
      class="star reset-btn-styling d-flex"
      @click="onStarClicked(value)"
    >
      <!-- here svg is directly in the template because otherwise svg package strips off unused linear gradient
         (which is actually being use for half start) -->
      <svg
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        :class="[
          'star__icon',
          { 'star__icon--filled': value <= roundedRating },
          {
            'star__icon--half-filled': isHalfStar(value),
          },
        ]"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.99267 0.30249C8.24722 0.302465 8.47294 0.466075 8.55213 0.707998L10.1449 5.57427L15.2649 5.5846C15.5195 5.58511 15.7449 5.74922 15.8235 5.99134C15.9022 6.23346 15.8163 6.4987 15.6106 6.64873L11.4731 9.66679L13.0462 14.5388C13.1245 14.7811 13.0381 15.0462 12.8321 15.1959C12.6261 15.3455 12.3473 15.3458 12.1411 15.1965L7.99277 12.1948L3.84564 15.1965C3.63941 15.3458 3.36059 15.3455 3.15461 15.1959C2.94863 15.0463 2.86219 14.7812 2.94036 14.5389L4.51244 9.66676L2.96338 8.53639C1.95898 7.80348 0.838963 6.98628 0.376127 6.64879C0.170117 6.49857 0.084244 6.23279 0.16341 5.99043C0.242577 5.74807 0.46878 5.58424 0.723742 5.5846C1.35304 5.58548 2.7382 5.58268 3.96739 5.57967C4.58168 5.57816 5.15658 5.5766 5.57791 5.57541L5.84154 5.57465L7.43329 0.708111C7.51242 0.466171 7.73812 0.302516 7.99267 0.30249Z"
        />
        <defs>
          <linearGradient id="HalfStar">
            <stop offset="50%" stop-color="#EEB730" />
            <stop offset="50%" stop-color="rgba(64,137,116, 0.25)" />
          </linearGradient>
        </defs>
      </svg>
    </component>
  </div>
</template>

<script>
import BaseButton from '~/components/BaseButton'

export default {
  components: {
    BaseButton,
  },
  props: {
    rating: {
      type: Number,
      default: 0,
    },
    onStarClicked: {
      type: Function,
      default: () => {},
    },
    renderStarsAsButtons: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ratingValues: [5, 4, 3, 2, 1],
    }
  },
  computed: {
    componentName() {
      return this.renderStarsAsButtons ? 'BaseButton' : 'div'
    },
    roundedRating() {
      if (this.rating > 0 && this.rating < 1) return 1

      return Math.ceil(this.rating * 2) / 2
    },
  },
  methods: {
    isHalfStar(value) {
      return (
        value === Math.ceil(this.roundedRating) &&
        !Number.isInteger(this.roundedRating)
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.star {
  padding-right: 4px;
}

.star__icon {
  fill: rgba($mint-dark, 0.25);
  width: 15.72px;
  height: 15.01px;
}

button {
  padding-right: 8px !important;

  .star__icon {
    width: 18.86px;
    height: 18.01px;
  }
}

.star__icon--filled {
  fill: $mustard-bright;
}

.star__icon--half-filled {
  fill: url(#HalfStar);
}

.stars-rating:hover {
  button .star__icon {
    fill: $grey-02;
  }
}

button:hover,
button:hover ~ button {
  .star__icon {
    fill: $mustard-bright !important;
  }
}
</style>
